import { useSubscriptionsApi } from '@api/payments/subscriptions.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( () => {
  void useSubscriptionsApi({ background: true })
})
